import { render, staticRenderFns } from "./newProduct.vue?vue&type=template&id=5c35262a&scoped=true"
import script from "./newProduct.vue?vue&type=script&lang=js"
export * from "./newProduct.vue?vue&type=script&lang=js"
import style0 from "./newProduct.vue?vue&type=style&index=0&id=5c35262a&prod&scoped=true&lang=css"
import style1 from "./newProduct.vue?vue&type=style&index=1&id=5c35262a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35262a",
  null
  
)

export default component.exports